function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

module.exports = function (modules) {
  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }

  var installedModules = {};
  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.i = function (value) {
    return value;
  }, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      configurable: !1,
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module["default"];
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 2);
}([function (module, exports, __webpack_require__) {
  __webpack_require__(6);

  var Component = __webpack_require__(7)(__webpack_require__(4), __webpack_require__(8), null, null);

  module.exports = Component.exports;
}, function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.d(__webpack_exports__, "a", function () {
    return props;
  }), __webpack_require__.d(__webpack_exports__, "b", function () {
    return getEventHandlers;
  });

  var props = {
    strings: {
      type: Array,
      required: !1,
      "default": function _default() {
        return ["Hello World!"];
      }
    },
    stringsElement: {
      type: String,
      required: !1,
      "default": null
    },
    typeSpeed: {
      type: Number,
      required: !1,
      "default": 50
    },
    startDelay: {
      type: Number,
      required: !1,
      "default": 0
    },
    backSpeed: {
      type: Number,
      required: !1,
      "default": 0
    },
    smartBackspace: {
      type: Boolean,
      required: !1,
      "default": !0
    },
    shuffle: {
      type: Boolean,
      required: !1,
      "default": !1
    },
    backDelay: {
      type: Number,
      required: !1,
      "default": 700
    },
    fadeOut: {
      type: Boolean,
      required: !1,
      "default": !1
    },
    fadeOutClass: {
      type: String,
      required: !1,
      "default": "typed-fade-out"
    },
    fadeOutDelay: {
      type: Number,
      required: !1,
      "default": 500
    },
    loop: {
      type: Boolean,
      required: !1,
      "default": !1
    },
    loopCount: {
      type: Number,
      required: !1,
      "default": 1 / 0
    },
    showCursor: {
      type: Boolean,
      required: !1,
      "default": !0
    },
    cursorChar: {
      type: String,
      required: !1,
      "default": "|"
    },
    autoInsertCss: {
      type: Boolean,
      required: !1,
      "default": !0
    },
    attr: {
      type: String,
      required: !1,
      "default": null
    },
    bindInputFocusEvents: {
      type: Boolean,
      required: !1,
      "default": !1
    },
    contentType: {
      type: String,
      required: !1,
      "default": "html"
    }
  },
      getEventHandlers = function getEventHandlers(context, typedConfig) {
    return typedConfig.onComplete = function () {
      context.$emit("onComplete");
    }, typedConfig.preStringTyped = function () {
      context.$emit("preStringTyped");
    }, typedConfig.onStringTyped = function () {
      context.$emit("onStringTyped");
    }, typedConfig.onLastStringBackspaced = function () {
      context.$emit("onLastStringBackspaced");
    }, typedConfig.onTypingPaused = function () {
      context.$emit("onTypingPaused");
    }, typedConfig.onTypingResumed = function () {
      context.$emit("onTypingResumed");
    }, typedConfig.onReset = function () {
      context.$emit("onReset");
    }, typedConfig.onStop = function () {
      context.$emit("onStop");
    }, typedConfig.onStart = function () {
      context.$emit("onStart");
    }, typedConfig.onDestroy = function () {
      context.$emit("onDestroy");
    }, typedConfig;
  };
}, function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  function install(Vue) {
    Vue.component("vue-typed-js", __WEBPACK_IMPORTED_MODULE_0__components_VueTypedJs_vue___default.a);
  }

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: !0
  }), __webpack_exports__.install = install;

  var __WEBPACK_IMPORTED_MODULE_0__components_VueTypedJs_vue__ = __webpack_require__(0),
      __WEBPACK_IMPORTED_MODULE_0__components_VueTypedJs_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_VueTypedJs_vue__);

  __webpack_require__.d(__webpack_exports__, "VueTypedJs", function () {
    return __WEBPACK_IMPORTED_MODULE_0__components_VueTypedJs_vue___default.a;
  });

  var plugin = {
    version: "0.1.2",
    install: install
  };
  __webpack_exports__["default"] = plugin;
  var GlobalVue = null;
  "undefined" != typeof window ? GlobalVue = window.Vue : "undefined" != typeof global && (GlobalVue = global.Vue), GlobalVue && GlobalVue.use(plugin);
}, function (module, exports, __webpack_require__) {
  (function (module) {
    var __WEBPACK_AMD_DEFINE_FACTORY__,
        __WEBPACK_AMD_DEFINE_ARRAY__,
        __WEBPACK_AMD_DEFINE_RESULT__,
        _typeof = "function" == typeof Symbol && "symbol" == _typeof2(Symbol.iterator) ? function (obj) {
      return _typeof2(obj);
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
    /*!
    * 
    *   typed.js - A JavaScript Typing Animation Library
    *   Author: Matt Boldt <me@mattboldt.com>
    *   Version: v2.0.6
    *   Url: https://github.com/mattboldt/typed.js
    *   License(s): MIT
    * 
    */


    !function (root, factory) {
      "object" === _typeof(exports) && "object" === _typeof(module) ? module.exports = factory() : (__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, void 0 !== (__WEBPACK_AMD_DEFINE_RESULT__ = "function" == typeof __WEBPACK_AMD_DEFINE_FACTORY__ ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__) && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }(0, function () {
      return function (modules) {
        function __webpack_require__(moduleId) {
          if (installedModules[moduleId]) return installedModules[moduleId].exports;
          var module = installedModules[moduleId] = {
            exports: {},
            id: moduleId,
            loaded: !1
          };
          return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.loaded = !0, module.exports;
        }

        var installedModules = {};
        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.p = "", __webpack_require__(0);
      }([function (module, exports, __webpack_require__) {
        "use strict";

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }

        Object.defineProperty(exports, "__esModule", {
          value: !0
        });

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
          };
        }(),
            _initializerJs = __webpack_require__(1),
            _htmlParserJs = __webpack_require__(3),
            Typed = function () {
          function Typed(elementId, options) {
            _classCallCheck(this, Typed), _initializerJs.initializer.load(this, options, elementId), this.begin();
          }

          return _createClass(Typed, [{
            key: "toggle",
            value: function value() {
              this.pause.status ? this.start() : this.stop();
            }
          }, {
            key: "stop",
            value: function value() {
              this.typingComplete || this.pause.status || (this.toggleBlinking(!0), this.pause.status = !0, this.options.onStop(this.arrayPos, this));
            }
          }, {
            key: "start",
            value: function value() {
              this.typingComplete || this.pause.status && (this.pause.status = !1, this.pause.typewrite ? this.typewrite(this.pause.curString, this.pause.curStrPos) : this.backspace(this.pause.curString, this.pause.curStrPos), this.options.onStart(this.arrayPos, this));
            }
          }, {
            key: "destroy",
            value: function value() {
              this.reset(!1), this.options.onDestroy(this);
            }
          }, {
            key: "reset",
            value: function value() {
              var restart = arguments.length <= 0 || void 0 === arguments[0] || arguments[0];
              clearInterval(this.timeout), this.replaceText(""), this.cursor && this.cursor.parentNode && (this.cursor.parentNode.removeChild(this.cursor), this.cursor = null), this.strPos = 0, this.arrayPos = 0, this.curLoop = 0, restart && (this.insertCursor(), this.options.onReset(this), this.begin());
            }
          }, {
            key: "begin",
            value: function value() {
              var _this = this;

              this.typingComplete = !1, this.shuffleStringsIfNeeded(this), this.insertCursor(), this.bindInputFocusEvents && this.bindFocusEvents(), this.timeout = setTimeout(function () {
                _this.currentElContent && 0 !== _this.currentElContent.length ? _this.backspace(_this.currentElContent, _this.currentElContent.length) : _this.typewrite(_this.strings[_this.sequence[_this.arrayPos]], _this.strPos);
              }, this.startDelay);
            }
          }, {
            key: "typewrite",
            value: function value(curString, curStrPos) {
              var _this2 = this;

              this.fadeOut && this.el.classList.contains(this.fadeOutClass) && (this.el.classList.remove(this.fadeOutClass), this.cursor && this.cursor.classList.remove(this.fadeOutClass));
              var humanize = this.humanizer(this.typeSpeed),
                  numChars = 1;
              if (!0 === this.pause.status) return void this.setPauseStatus(curString, curStrPos, !0);
              this.timeout = setTimeout(function () {
                curStrPos = _htmlParserJs.htmlParser.typeHtmlChars(curString, curStrPos, _this2);
                var pauseTime = 0,
                    substr = curString.substr(curStrPos);

                if ("^" === substr.charAt(0) && /^\^\d+/.test(substr)) {
                  var skip = 1;
                  substr = /\d+/.exec(substr)[0], skip += substr.length, pauseTime = parseInt(substr), _this2.temporaryPause = !0, _this2.options.onTypingPaused(_this2.arrayPos, _this2), curString = curString.substring(0, curStrPos) + curString.substring(curStrPos + skip), _this2.toggleBlinking(!0);
                }

                if ("`" === substr.charAt(0)) {
                  for (; "`" !== curString.substr(curStrPos + numChars).charAt(0) && (numChars++, !(curStrPos + numChars > curString.length));) {
                    ;
                  }

                  var stringBeforeSkip = curString.substring(0, curStrPos),
                      stringSkipped = curString.substring(stringBeforeSkip.length + 1, curStrPos + numChars),
                      stringAfterSkip = curString.substring(curStrPos + numChars + 1);
                  curString = stringBeforeSkip + stringSkipped + stringAfterSkip, numChars--;
                }

                _this2.timeout = setTimeout(function () {
                  _this2.toggleBlinking(!1), curStrPos === curString.length ? _this2.doneTyping(curString, curStrPos) : _this2.keepTyping(curString, curStrPos, numChars), _this2.temporaryPause && (_this2.temporaryPause = !1, _this2.options.onTypingResumed(_this2.arrayPos, _this2));
                }, pauseTime);
              }, humanize);
            }
          }, {
            key: "keepTyping",
            value: function value(curString, curStrPos, numChars) {
              0 === curStrPos && (this.toggleBlinking(!1), this.options.preStringTyped(this.arrayPos, this)), curStrPos += numChars;
              var nextString = curString.substr(0, curStrPos);
              this.replaceText(nextString), this.typewrite(curString, curStrPos);
            }
          }, {
            key: "doneTyping",
            value: function value(curString, curStrPos) {
              var _this3 = this;

              this.options.onStringTyped(this.arrayPos, this), this.toggleBlinking(!0), this.arrayPos === this.strings.length - 1 && (this.complete(), !1 === this.loop || this.curLoop === this.loopCount) || (this.timeout = setTimeout(function () {
                _this3.backspace(curString, curStrPos);
              }, this.backDelay));
            }
          }, {
            key: "backspace",
            value: function value(curString, curStrPos) {
              var _this4 = this;

              if (!0 === this.pause.status) return void this.setPauseStatus(curString, curStrPos, !0);
              if (this.fadeOut) return this.initFadeOut();
              this.toggleBlinking(!1);
              var humanize = this.humanizer(this.backSpeed);
              this.timeout = setTimeout(function () {
                curStrPos = _htmlParserJs.htmlParser.backSpaceHtmlChars(curString, curStrPos, _this4);
                var curStringAtPosition = curString.substr(0, curStrPos);

                if (_this4.replaceText(curStringAtPosition), _this4.smartBackspace) {
                  var nextString = _this4.strings[_this4.arrayPos + 1];
                  nextString && curStringAtPosition === nextString.substr(0, curStrPos) ? _this4.stopNum = curStrPos : _this4.stopNum = 0;
                }

                curStrPos > _this4.stopNum ? (curStrPos--, _this4.backspace(curString, curStrPos)) : curStrPos <= _this4.stopNum && (_this4.arrayPos++, _this4.arrayPos === _this4.strings.length ? (_this4.arrayPos = 0, _this4.options.onLastStringBackspaced(), _this4.shuffleStringsIfNeeded(), _this4.begin()) : _this4.typewrite(_this4.strings[_this4.sequence[_this4.arrayPos]], curStrPos));
              }, humanize);
            }
          }, {
            key: "complete",
            value: function value() {
              this.options.onComplete(this), this.loop ? this.curLoop++ : this.typingComplete = !0;
            }
          }, {
            key: "setPauseStatus",
            value: function value(curString, curStrPos, isTyping) {
              this.pause.typewrite = isTyping, this.pause.curString = curString, this.pause.curStrPos = curStrPos;
            }
          }, {
            key: "toggleBlinking",
            value: function value(isBlinking) {
              if (this.cursor && !this.pause.status && this.cursorBlinking !== isBlinking) {
                this.cursorBlinking = isBlinking;
                var status = isBlinking ? "infinite" : 0;
                this.cursor.style.animationIterationCount = status;
              }
            }
          }, {
            key: "humanizer",
            value: function value(speed) {
              return Math.round(Math.random() * speed / 2) + speed;
            }
          }, {
            key: "shuffleStringsIfNeeded",
            value: function value() {
              this.shuffle && (this.sequence = this.sequence.sort(function () {
                return Math.random() - .5;
              }));
            }
          }, {
            key: "initFadeOut",
            value: function value() {
              var _this5 = this;

              return this.el.className += " " + this.fadeOutClass, this.cursor && (this.cursor.className += " " + this.fadeOutClass), setTimeout(function () {
                _this5.arrayPos++, _this5.replaceText(""), _this5.strings.length > _this5.arrayPos ? _this5.typewrite(_this5.strings[_this5.sequence[_this5.arrayPos]], 0) : (_this5.typewrite(_this5.strings[0], 0), _this5.arrayPos = 0);
              }, this.fadeOutDelay);
            }
          }, {
            key: "replaceText",
            value: function value(str) {
              this.attr ? this.el.setAttribute(this.attr, str) : this.isInput ? this.el.value = str : "html" === this.contentType ? this.el.innerHTML = str : this.el.textContent = str;
            }
          }, {
            key: "bindFocusEvents",
            value: function value() {
              var _this6 = this;

              this.isInput && (this.el.addEventListener("focus", function (e) {
                _this6.stop();
              }), this.el.addEventListener("blur", function (e) {
                _this6.el.value && 0 !== _this6.el.value.length || _this6.start();
              }));
            }
          }, {
            key: "insertCursor",
            value: function value() {
              this.showCursor && (this.cursor || (this.cursor = document.createElement("span"), this.cursor.className = "typed-cursor", this.cursor.innerHTML = this.cursorChar, this.el.parentNode && this.el.parentNode.insertBefore(this.cursor, this.el.nextSibling)));
            }
          }]), Typed;
        }();

        exports["default"] = Typed, module.exports = exports["default"];
      }, function (module, exports, __webpack_require__) {
        "use strict";

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }

        Object.defineProperty(exports, "__esModule", {
          value: !0
        });

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
            }
          }

          return target;
        },
            _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
          };
        }(),
            _defaultsJs = __webpack_require__(2),
            _defaultsJs2 = function (obj) {
          return obj && obj.__esModule ? obj : {
            "default": obj
          };
        }(_defaultsJs),
            Initializer = function () {
          function Initializer() {
            _classCallCheck(this, Initializer);
          }

          return _createClass(Initializer, [{
            key: "load",
            value: function value(self, options, elementId) {
              if (self.el = "string" == typeof elementId ? document.querySelector(elementId) : elementId, self.options = _extends({}, _defaultsJs2["default"], options), self.isInput = "input" === self.el.tagName.toLowerCase(), self.attr = self.options.attr, self.bindInputFocusEvents = self.options.bindInputFocusEvents, self.showCursor = !self.isInput && self.options.showCursor, self.cursorChar = self.options.cursorChar, self.cursorBlinking = !0, self.elContent = self.attr ? self.el.getAttribute(self.attr) : self.el.textContent, self.contentType = self.options.contentType, self.typeSpeed = self.options.typeSpeed, self.startDelay = self.options.startDelay, self.backSpeed = self.options.backSpeed, self.smartBackspace = self.options.smartBackspace, self.backDelay = self.options.backDelay, self.fadeOut = self.options.fadeOut, self.fadeOutClass = self.options.fadeOutClass, self.fadeOutDelay = self.options.fadeOutDelay, self.isPaused = !1, self.strings = self.options.strings.map(function (s) {
                return s.trim();
              }), "string" == typeof self.options.stringsElement ? self.stringsElement = document.querySelector(self.options.stringsElement) : self.stringsElement = self.options.stringsElement, self.stringsElement) {
                self.strings = [], self.stringsElement.style.display = "none";
                var strings = Array.prototype.slice.apply(self.stringsElement.children),
                    stringsLength = strings.length;
                if (stringsLength) for (var i = 0; i < stringsLength; i += 1) {
                  var stringEl = strings[i];
                  self.strings.push(stringEl.innerHTML.trim());
                }
              }

              self.strPos = 0, self.arrayPos = 0, self.stopNum = 0, self.loop = self.options.loop, self.loopCount = self.options.loopCount, self.curLoop = 0, self.shuffle = self.options.shuffle, self.sequence = [], self.pause = {
                status: !1,
                typewrite: !0,
                curString: "",
                curStrPos: 0
              }, self.typingComplete = !1;

              for (var i in self.strings) {
                self.sequence[i] = i;
              }

              self.currentElContent = this.getCurrentElContent(self), self.autoInsertCss = self.options.autoInsertCss, this.appendAnimationCss(self);
            }
          }, {
            key: "getCurrentElContent",
            value: function value(self) {
              return self.attr ? self.el.getAttribute(self.attr) : self.isInput ? self.el.value : "html" === self.contentType ? self.el.innerHTML : self.el.textContent;
            }
          }, {
            key: "appendAnimationCss",
            value: function value(self) {
              if (self.autoInsertCss && self.showCursor && self.fadeOut) {
                var css = document.createElement("style");
                css.type = "text/css";
                var innerCss = "";
                self.showCursor && (innerCss += "\n        .typed-cursor{\n          opacity: 1;\n          animation: typedjsBlink 0.7s infinite;\n          -webkit-animation: typedjsBlink 0.7s infinite;\n                  animation: typedjsBlink 0.7s infinite;\n        }\n        @keyframes typedjsBlink{\n          50% { opacity: 0.0; }\n        }\n        @-webkit-keyframes typedjsBlink{\n          0% { opacity: 1; }\n          50% { opacity: 0.0; }\n          100% { opacity: 1; }\n        }\n      "), self.fadeOut && (innerCss += "\n        .typed-fade-out{\n          opacity: 0;\n          transition: opacity .25s;\n          -webkit-animation: 0;\n                  animation: 0;\n        }\n      "), 0 !== css.length && (css.innerHTML = innerCss, document.body.appendChild(css));
              }
            }
          }]), Initializer;
        }();

        exports["default"] = Initializer;
        var initializer = new Initializer();
        exports.initializer = initializer;
      }, function (module, exports) {
        "use strict";

        Object.defineProperty(exports, "__esModule", {
          value: !0
        });
        var defaults = {
          strings: ["These are the default values...", "You know what you should do?", "Use your own!", "Have a great day!"],
          stringsElement: null,
          typeSpeed: 0,
          startDelay: 0,
          backSpeed: 0,
          smartBackspace: !0,
          shuffle: !1,
          backDelay: 700,
          fadeOut: !1,
          fadeOutClass: "typed-fade-out",
          fadeOutDelay: 500,
          loop: !1,
          loopCount: 1 / 0,
          showCursor: !0,
          cursorChar: "|",
          autoInsertCss: !0,
          attr: null,
          bindInputFocusEvents: !1,
          contentType: "html",
          onComplete: function onComplete(self) {},
          preStringTyped: function preStringTyped(arrayPos, self) {},
          onStringTyped: function onStringTyped(arrayPos, self) {},
          onLastStringBackspaced: function onLastStringBackspaced(self) {},
          onTypingPaused: function onTypingPaused(arrayPos, self) {},
          onTypingResumed: function onTypingResumed(arrayPos, self) {},
          onReset: function onReset(self) {},
          onStop: function onStop(arrayPos, self) {},
          onStart: function onStart(arrayPos, self) {},
          onDestroy: function onDestroy(self) {}
        };
        exports["default"] = defaults, module.exports = exports["default"];
      }, function (module, exports) {
        "use strict";

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }

        Object.defineProperty(exports, "__esModule", {
          value: !0
        });

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
          };
        }(),
            HTMLParser = function () {
          function HTMLParser() {
            _classCallCheck(this, HTMLParser);
          }

          return _createClass(HTMLParser, [{
            key: "typeHtmlChars",
            value: function value(curString, curStrPos, self) {
              if ("html" !== self.contentType) return curStrPos;
              var curChar = curString.substr(curStrPos).charAt(0);

              if ("<" === curChar || "&" === curChar) {
                var endTag = "";

                for (endTag = "<" === curChar ? ">" : ";"; curString.substr(curStrPos + 1).charAt(0) !== endTag && !(++curStrPos + 1 > curString.length);) {
                  ;
                }

                curStrPos++;
              }

              return curStrPos;
            }
          }, {
            key: "backSpaceHtmlChars",
            value: function value(curString, curStrPos, self) {
              if ("html" !== self.contentType) return curStrPos;
              var curChar = curString.substr(curStrPos).charAt(0);

              if (">" === curChar || ";" === curChar) {
                var endTag = "";

                for (endTag = ">" === curChar ? "<" : "&"; curString.substr(curStrPos - 1).charAt(0) !== endTag && !(--curStrPos < 0);) {
                  ;
                }

                curStrPos--;
              }

              return curStrPos;
            }
          }]), HTMLParser;
        }();

        exports["default"] = HTMLParser;
        var htmlParser = new HTMLParser();
        exports.htmlParser = htmlParser;
      }]);
    });
  }).call(exports, __webpack_require__(5)(module));
}, function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  Object.defineProperty(__webpack_exports__, "__esModule", {
    value: !0
  });

  var __WEBPACK_IMPORTED_MODULE_0_typed_js__ = __webpack_require__(3),
      __WEBPACK_IMPORTED_MODULE_0_typed_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_typed_js__),
      __WEBPACK_IMPORTED_MODULE_1__config_typed_component_config__ = __webpack_require__(1);

  __webpack_exports__["default"] = {
    name: "vue-typed-js",
    props: __WEBPACK_IMPORTED_MODULE_1__config_typed_component_config__.a,
    data: function data() {
      return {
        typedObj: null
      };
    },
    methods: {
      throwError: function throwError(message) {
        throw new TypeError(message);
      },
      initTypedJS: function initTypedJS() {
        var $typed = this.$refs.typedElement.querySelector(".typing");
        if (this.$slots["default"].length > 1) this.throwError("Just one child element allowed inside <" + this.$options.name + "> component.");else if (1 === this.$slots["default"].length) {
          var typedConfig = this.$props;
          typedConfig = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__config_typed_component_config__.b)(this, typedConfig), this.typedObj = new __WEBPACK_IMPORTED_MODULE_0_typed_js___default.a($typed, typedConfig);
        }
      }
    },
    mounted: function mounted() {
      this.initTypedJS();
    }
  };
}, function (module, exports) {
  module.exports = function (module) {
    return module.webpackPolyfill || (module.deprecate = function () {}, module.paths = [], module.children || (module.children = []), Object.defineProperty(module, "loaded", {
      enumerable: !0,
      get: function get() {
        return module.l;
      }
    }), Object.defineProperty(module, "id", {
      enumerable: !0,
      get: function get() {
        return module.i;
      }
    }), module.webpackPolyfill = 1), module;
  };
}, function (module, exports) {}, function (module, exports) {
  module.exports = function (rawScriptExports, compiledTemplate, scopeId, cssModules) {
    var esModule,
        scriptExports = rawScriptExports = rawScriptExports || {},
        type = _typeof2(rawScriptExports["default"]);

    "object" !== type && "function" !== type || (esModule = rawScriptExports, scriptExports = rawScriptExports["default"]);
    var options = "function" == typeof scriptExports ? scriptExports.options : scriptExports;

    if (compiledTemplate && (options.render = compiledTemplate.render, options.staticRenderFns = compiledTemplate.staticRenderFns), scopeId && (options._scopeId = scopeId), cssModules) {
      var computed = options.computed || (options.computed = {});
      Object.keys(cssModules).forEach(function (key) {
        var module = cssModules[key];

        computed[key] = function () {
          return module;
        };
      });
    }

    return {
      esModule: esModule,
      exports: scriptExports,
      options: options
    };
  };
}, function (module, exports) {
  module.exports = {
    render: function render() {
      var _vm = this,
          _h = _vm.$createElement;

      return (_vm._self._c || _h)("div", {
        ref: "typedElement",
        staticClass: "typed-element"
      }, [_vm._t("default")], 2);
    },
    staticRenderFns: []
  };
}]);